import { FC, Fragment } from 'react';
import OptionalService from './OptionalService';
import { Pax } from 'ts/dynamic/interfaces/DynamicBookResponse';
import { BookOptionsCatalogue } from 'ts/dynamic/classes/BookOptionsCatalogue';

interface OptionalServicesProps {
  catalogue: BookOptionsCatalogue;
  pax: Pax;
  paxIndex: number;
  onChangeField: (newPax: Pax, index: number) => void;
  flightSource: string;
}

const OptionalServices: FC<OptionalServicesProps> = ({ catalogue, pax, ...props }) => {
  return (
    <Fragment>
      {catalogue.visible &&
        [
          ...catalogue.outboundBaggage.paxTypes,
          ...catalogue.outboundMeal.paxTypes,
          ...catalogue.inboundBaggage.paxTypes,
          ...catalogue.inboundMeal.paxTypes,
        ].includes(pax.paxTypeCode) && (
          <div className="form-wrapper row">
            <OptionalService
              pax={pax}
              paxIndex={props.paxIndex}
              bagMeal={catalogue.outboundBaggage}
              flightSource={props.flightSource}
              onChangeField={props.onChangeField}
              key1="baggageOutbound"
            />
            <OptionalService
              pax={pax}
              paxIndex={props.paxIndex}
              flightSource={props.flightSource}
              onChangeField={props.onChangeField}
              bagMeal={catalogue.outboundMeal}
              key1="mealOutbound"
            />
            <OptionalService
              pax={pax}
              paxIndex={props.paxIndex}
              bagMeal={catalogue.inboundBaggage}
              flightSource={props.flightSource}
              onChangeField={props.onChangeField}
              key1="baggageInbound"
            />
            <OptionalService
              pax={pax}
              paxIndex={props.paxIndex}
              flightSource={props.flightSource}
              onChangeField={props.onChangeField}
              bagMeal={catalogue.inboundMeal}
              key1="mealInbound"
            />
          </div>
        )}
    </Fragment>
  );
};

export default OptionalServices;
